import React, { useEffect, useState } from "react";
import {  WeightageVM } from "../../../Models/ViewModels";
import { GetUserLoginID } from "../../../Services/UserSessionManager";
import { ToastContainer, toast } from 'react-toastify';
import ModalHeader from "rsuite/esm/Modal/ModalHeader";
import ModalTitle from "rsuite/esm/Modal/ModalTitle";
import ModalBody from "rsuite/esm/Modal/ModalBody";
import { Button, Input, Modal } from "rsuite";
import { AddWeightage, DeleteWeightage, EditWeightage, GetSubStateProcess } from "../../../Services/WeightageDB";
import { GetProcessDetails } from "../../../Services/ProcessDB";
import { GetAccountDetails } from "../../../Services/AccountsDB";

type attributes = {
 
    type:string,
    title:string  , 
    data:WeightageVM;
    onAction: any;
    cachedData:Array<WeightageVM>;
  }

  export const AddEditDeleteWeightage=(props:attributes)=>{
    const[loginid,setLoginid]=useState(GetUserLoginID())
    const[newWeightage,setNewWeightage]=useState(new WeightageVM())
    const [open, setOpen] = React.useState(true);
  const [displayButton,setDisplayButton]=useState(false)
  const[process,SetProcess]=useState([])
  const[Processname,SetProcessName]=useState("");
  const[account,SetAccount]=useState([])
  const[subState,SetSubstate]=useState([])


  useEffect(() => {
    setNewWeightage(props.data)
    if(props.type=='edit')
    {
      GetSubState(props.data.ProcessName)
      setDisplayButton(true)
    }
    GetProcessName();
    GetAccountName();
  
    
  }, []) 
    const handleClose = () =>{
        setOpen(false);
        }
    const handelProcessModification=()=>{
        
        if(props.type=='edit'){
            EditWeightage(newWeightage,loginid).then((res)=>{
                props.onAction();
                handleClose();
                   toast.info("Updated successfully !");
            }).catch((err)=>{
                toast.error("Failed to Update !");}
            )
        }

         else if(props.type=='add'){
            AddWeightage(newWeightage,loginid).then((res)=>{
              if(res.data==1){
                props.onAction();
                handleClose();
                 toast.success("Added successfully")
              }
              else
                toast.error("Account trying to add is already Active!")
            }).catch((err)=>{
                toast.error("Failed to Add !")
            })
        }
        else if(props.type=='delete'){
            
            DeleteWeightage(newWeightage.WeightageID).then((res)=>{
                props.onAction();
                handleClose();
               toast.error("Deleted successfully")
            }).catch((err)=>{
                toast.error("Failed to Delete !");
            })
        }
    }
    const GetProcessName=()=>{
        GetProcessDetails().then((res)=>{
           SetProcess(res.data)
        })
    }

    const GetAccountName=()=>{
        GetAccountDetails().then((res)=>{
           SetAccount(res.data)
        })
    }
    const GetSubState=(Processname:string)=>{
        GetSubStateProcess(Processname).then((res)=>{
            SetSubstate(res.data);
        })
    }

    const handleInput = (value:any,event:any) => {
        console.log(event)
        let value1 = event.target.type === 'number' ? +event.target.value : event.target.value;
        setNewWeightage({...newWeightage, [event.target.name]:value1});
        
    }

    const handleInputDropDownProcess = (event:any) => {
        let value = event.target.type === 'number' ? +event.target.value : event.target.value;
        setNewWeightage({...newWeightage, [event.target.name]:value});
        GetSubState(value)

    
    }
    const handleInputDropDown = (event:any) => {
        let value = event.target.type === 'number' ? +event.target.value : event.target.value;
        setNewWeightage({...newWeightage, [event.target.name]:value});
       
    }

    if(props.type=='delete'){
        return(
        <div className="modal-container">
       <ModalHeader>
         <ModalTitle><h4>{props.title}</h4></ModalTitle>
       </ModalHeader>
       <ModalBody>
        Are you sure you want to delete {newWeightage.ProcessName}
       </ModalBody>
       <Modal.Footer>
              <Button onClick={handelProcessModification} appearance="primary">
              Delete
              </Button>
            </Modal.Footer>
       </div>
        )
      }
    else{
        return (
            <div className="modal-container"> 
                <Modal.Header>
                  <Modal.Title><h3>{props.title}</h3></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                <ModalTitle >Account Name</ModalTitle>
                <select id="select" 
                  name="AccountName" 
                  value={newWeightage.AccountName}
                  onChange={handleInputDropDown}
               >
                        {account.map((a:any)=>{
                         if(a===null)
                         return(<></>)
                         else if(a.IsActive==="Active"){
                            return(
                                
                                <option value={a.AccountName}>{a.AccountName}</option>
                            )
                         }
                        })
                   }
                   </select>
                <ModalTitle >Process Name</ModalTitle>
                <select id="select" 
                  name="ProcessName" 
                  value={newWeightage.ProcessName}
                  onChange={handleInputDropDownProcess}
               >
                   <option className="bg-secondary text-light">Select-Process</option>
                   {process.map((p:any)=>{
                         if(p===null)
                         return(<></>)
                         else if(p.IsActive==="Active"){
                            return(

                                <option value={p.ProcessName}>{p.ProcessName}</option>
                            )
                         }
                        })
                   }
                   </select>
                   <ModalTitle >SubState Name</ModalTitle>
                <select id="select" 
                  name="SubStateName" 
                  value={newWeightage.SubStateName}
                  onChange={handleInputDropDown}
               >
                   <option className="bg-secondary text-light">Select-Substate</option>
                   {subState.map((s:any)=>{
                         if(s===null)
                         return(<></>)
                         else{
                            return(
                                <option value={s.SubStateName}>{s.SubStateName}</option>
                            )
                         }
                        })
                   }
                   </select>
                   <ModalTitle >Target 1</ModalTitle>
                <Input type="number" name="Target1" value={newWeightage.Target1} onChange={(value,event)=>handleInput(value,event)}/>
                <ModalTitle >Target 2</ModalTitle>
                <Input type="number" name="Target2" value={newWeightage.Target2} onChange={(value,event)=>handleInput(value,event)}/>
                <ModalTitle >Target 3</ModalTitle>
                <Input type="number" name="Target3" value={newWeightage.Target3} onChange={(value,event)=>handleInput(value,event)}/>
                </Modal.Body>
                {displayButton?
                    <Modal.Footer>   <Button onClick={handelProcessModification} appearance="primary">
                    Update
                    </Button> 
                    </Modal.Footer>
                    :
                    <Modal.Footer><Button onClick={handelProcessModification} appearance="primary">
                     Add
                    </Button>
                    </Modal.Footer>
                }
            </div>
        )
                
    }
     
  }